// Module-level cache for the DynamicWeb API hostname.
// Hydrated once by AppSettingsProvider from app_settings.api_hostname.
// Synchronous utilities (e.g. imageHandler) read it via getApiHostname().
// No hardcoded fallback: callers must wait for hydration or handle the empty state.

let _apiHostname = '';

export function setApiHostname(value: string | undefined | null): void {
  if (!value) {
    _apiHostname = '';
    return;
  }
  _apiHostname = value.replace(/\/+$/, '');
}

export function getApiHostname(): string {
  return _apiHostname;
}

export function hasApiHostname(): boolean {
  return _apiHostname.length > 0;
}
